/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Akcie',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Poskytnúť spätnú väzbu',
  'ai-smart-button.ai-actions.help.section.text': 'Pomocník',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Prepojenie',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Spomenutie',
  'ai-smart-button.ai-actions.input.send-button-label': 'Odoslať',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NOVÉ',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Ikona automatizácie',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Vytvoriť automatizáciu',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Dobrý deň, {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Zrušiť',
  'ai-smart-button.feedback-action.ask-question-option': 'Položiť otázku',
  'ai-smart-button.feedback-action.cancel-button-label': 'Zrušiť',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Vyberte možnosť',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Opísať chybu alebo problém',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': "Let us know what's on your mind",
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Čo by ste chceli vedieť?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Dajte nám vedieť, čo by ste chceli zlepšiť',
  'ai-smart-button.feedback-action.feedback-modal-heading': 'Podeľte sa o svoje myšlienky',
  'ai-smart-button.feedback-action.leave-comment-option': 'Zanechajte komentár',
  'ai-smart-button.feedback-action.report-bug-option': 'Nahlásiť chybu',
  'ai-smart-button.feedback-action.research-participation-message': 'Chcem sa zúčastniť produktového prieskumu',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Vyberte spätnú väzbu',
  'ai-smart-button.feedback-action.submit-button-label': 'Odoslať spätnú väzbu',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Navrhnúť zlepšenie',
  'ai-smart-button.feedback-action.title': 'Poskytnúť spätnú väzbu',
  'ai-smart-button.reference.close-button-label': 'Zatvoriť',
};
